import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BaseUrlHelperService } from "../../../shared/helper/baseUrlHelper.service";
import { ContactUsService } from "../../../shared/services/contact-us.service";
import { SharedDataService } from "../../../shared/sharedData.service";

@Component({
    selector: "app-contact-us",
    templateUrl: "./contact-us.component.html",
    standalone: false
})
export class ContactUsComponent implements OnInit {
    isDisabled;
    showAlertMessage;

    userInfo = window.preload.user;
    model: any = {
        fullName: "",
        firstName: "",
        lastName: "",
        message: "",
        subject: "",
        ssoid: "",
        email: "",
        contactExt: "",
        contactNo: "",
        filePath: "",
        userId: "",
        fileTimeStamp: "",
    };
    alerts;
    fileData: any;
    previewUrl;
    uploadText = "";
    fileNames = [];

    componentDestroyed$: Subject<boolean> = new Subject();

    constructor(
        private contactUsService: ContactUsService,
        private _apiroot: BaseUrlHelperService,
        private router: Router,
        private _sharedDataService: SharedDataService
    ) {}
    ngOnInit(): void {
        //Interaction with services for CRUD operations.
        //Get data from services on page load.
        this._sharedDataService.setCss("help");
        this.contactUsService
            .loadContactusData(this.userInfo.id, 0)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (response) => {
                    if (response.email !== "") {
                        this.model = response;
                        //this.model.ssoid = window.preload.user.id;
                        this.getFullName();
                        this.isDisabled = true;
                    } else {
                        // this.model = {};
                        this.isDisabled = false;
                    }
                },
                (error) => {}
            );
    }

    captchaSubmitted = false;
    FileTimeStamp = Math.floor(Date.now() / 1000);

    getFullName() {
        this.model.fullName = this.model.firstName + " " + this.model.lastName;
    }

    //apiUrl = this._apiroot.baseUrl + this.FileTimeStamp + "/UploadAttachment";
    //uploadUrl = this.apiUrl;

    uploaded(fileResponse) {
        const file = <File>fileResponse.target.files[0];
        const testData: FormData = new FormData();
        testData.append("file", file, file.name);
        this.contactUsService
            .postFile(testData, this.FileTimeStamp)
            .subscribe((uploadedResponse) => {
                this.fileData = uploadedResponse;
                if (this.fileData.status === "true") {
                    this.model.filePath = this.fileData.relativeUrl;
                    this.uploadText = this.fileData.fileName0;
                    //this.model.fileTimeStamp = this.fileData.fileTimeStamp;
                    const fileCount = parseInt(this.fileData.count, 10);
                    if (fileCount > 0) {
                        for (let i = 0; i < fileCount; i++) {
                            const filename = "fileName" + i;
                            this.fileNames.push({
                                file: this.fileData[filename],
                            });
                        }
                    }
                } else {
                    if (this.fileData.filesizeerror) {
                        this.showAlertMessage = true;
                        this.alerts = [
                            {
                                type: "danger",
                                msg: this.fileData.filesizeerror,
                            },
                        ];
                    }
                }
            });
    }

    closeAlert() {
        this.alerts = [];
        this.showAlertMessage = false;
    }

    //Post data to the database and navigate to next page.
    submitContactUsDetails(data) {
        const request = data.form.value;
        request["filePath"] = this.model.filePath;
        if (data.form.status == "VALID") {
            this.contactUsService
                .sendContactusData(request)
                .pipe(takeUntil(this.componentDestroyed$))
                .subscribe(
                    (response) => {
                        if (response === "Success") {
                            this.router.navigateByUrl("Help/Thanks");
                        } else {
                            // this.error = true;
                        }
                    },
                    (error) => {}
                );
        }
    }

    // File delete functionality start
    deleteFileUpload(file, index, filePath) {
        const fileToDelete = filePath + "\\" + file;
        const response = { responsemessage: fileToDelete };
        this.contactUsService.deleteUploadedDoc(response).subscribe(
            (response) => {
                if (response["responseMessage"] === "Success") {
                    this.fileNames.splice(index, 1);
                } else {
                    //this.error = true;
                }
            },
            (error) => {
                //error
            }
        );
    }

    // File delete functionality End
    ngOnDestroy() {
        this.componentDestroyed$.next(true);
        this.componentDestroyed$.complete();
    }
}
